export default __webpack_public_path__ + "static/media/permeable-blog-7.32393248.jpg";